import { render, staticRenderFns } from "./TabelaDeCelulas.vue?vue&type=template&id=786fb7da&"
import script from "./TabelaDeCelulas.vue?vue&type=script&lang=js&"
export * from "./TabelaDeCelulas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
